<template>
  <div
    id="pravaler-button"
    @click="$emit('click')"
    :style="cssVars"
  >
    <CloseComponent
      @click="close"
      top="-18px"
      right="5px"
      size="12px"
      type="close"
    />
    <img
      src="@/assets/logo-without-background.svg"
      width="30px"
      height="30px"
    >
    <span>{{ config.visual.button_text }}</span>
  </div>
</template>
<script setup lang="ts">
import { computed } from 'vue';
import { appStore } from '@/store/app';
import type { IConfig } from './forms/interface/IConfig';
import CloseComponent from './CloseComponent.vue';

const emits = defineEmits(['click', 'close']);
const config = appStore().getConfig() as IConfig;

const cssVars = computed(() => {
  const width = (config.visual.button_text.length * 10) + 75;
  return {
    ['--width-hover']: (width || 50) + 'px'
  };
});

function close(event) {
  event.stopPropagation();
  emits('close');
}
</script>

<style lang="scss" scoped>
#pravaler-button {
  position: absolute;
  z-index: 99999999;
  cursor: pointer;

  transition: width 0.5s;

  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;

  background-color: var(--primary);
  padding: 10px;
  height: 50px;
  width: 50px;
  max-width: 357px;

  border-radius: 50px;

  &>img {
    width: 30px;
  }

  &>span {
    display: none;
    color: transparent;
    margin: 0 16px;
    text-wrap: nowrap;
    overflow: hidden;
  }

  &:hover {
    width: var(--width-hover);

    &>span {
      position: relative;
      display: unset;
      color: var(--contrast-text-primary);
    }
  }
}
</style>